export default "__VITE_ASSET__C9vUJ1A___"